const DEFAULT_DATA = { loading: true, loaded: false };

const getFlags = (state, id) => state.document.decision.summary[id];
const getSummary = (state, id) => state.entities.decision[id].summary;
const getContractGenPermissionsFlags = (state, id) => state.document.decision.contractGenPermissions[id];
const getPermissions = (state, id) => state.entities.decision[id].contractGenPermissions;

export const getDecisionSummary = (state, key) => {
  const flags = getFlags(state, key);
  if (!flags || !flags.loaded || flags.loading) return DEFAULT_DATA;

  const summary = getSummary(state, key);
  return {
    ...summary,
    ...flags
  };
};

export const getContractGenPermissions = (state, key) => {
  const flags = getContractGenPermissionsFlags(state, key);
  if (!flags || !flags.loaded || flags.loading) return DEFAULT_DATA;

  const contractGenPermissions = getPermissions(state, key);
  return {
    ...contractGenPermissions,
    ...flags
  };
};
